// components/MonthFilterPanel.js
import React from "react";

const MonthFilter = ({
  months,
  selectedMonth,
  handleMonthSelect,
  selectedYear,
  handleYearChange,
  filterDay,
  setFilterDay,
  filterStatusP,
  setFilterStatusP,
  filterModel,
  setFilterModel,
  handleClear,
  getDaysInMonth,
  isMobile,
}) => {
  return isMobile ? (
    <div className="flex flex-col my-2">
      <select
        className="border p-2 m-2"
        value={selectedMonth}
        onChange={(e) => handleMonthSelect(e.target.value)}
      >
        <option value="" disabled>Select Month</option>
        {months.map((month) => (
          <option key={month} value={month}>{month}</option>
        ))}
        <option value="">All</option>
      </select>

      <select
        name="filterDay"
        className="border p-2 m-2"
        value={filterDay}
        onChange={(e) => setFilterDay(e.target.value)}
        disabled={!selectedMonth}
      >
        <option value="" disabled>Filter by Day</option>
        {selectedMonth &&
          Array.from({ length: getDaysInMonth(selectedMonth) }, (_, i) => i + 1)
            .map((day) => (
              <option key={day} value={day}>{day}</option>
            ))}
      </select>

      <select
        name="filterStatusP"
        className="border p-2 m-2"
        value={filterStatusP}
        onChange={(e) => setFilterStatusP(e.target.value)}
      >
        <option value="">Filter by Status</option>
        <option value="Ordered">Ordered</option>
        <option value="Received">Received</option>
        <option value="Sent">Sent</option>
        <option value="Sold">Sold</option>
        <option value="Custom">Custom</option>
        <option value="Returned">Returned</option>
        <option value="Unpaid">Unpaid</option>
      </select>

      <input
        type="text"
        name="model"
        className="border p-2 m-2"
        placeholder="Filtered by Model"
        value={filterModel}
        onChange={(e) => setFilterModel(e.target.value)}
      />

      <button
        onClick={handleClear}
        className="border p-2 m-2 bg-slate-500 hover:bg-slate-300 rounded"
      >
        Clear
      </button>
    </div>
  ) : (
    <div className="flex flex-row m-2 p-2">
      <div className="w-3/4 mb-5">
        <select
          className="border p-2 m-2"
          value={selectedMonth}
          onChange={(e) => handleMonthSelect(e.target.value)}
        >
          <option value="" disabled>Filter by Month</option>
          {months.map((month) => (
            <option key={month} value={month}>{month}</option>
          ))}
          <option value="">All</option>
        </select>
        <label htmlFor="year-select" className="mx-3 font-bold">
          Year:
        </label>
        <input
          id="year-select"
          type="number"
          value={selectedYear}
          onChange={handleYearChange}
          min="2000"
          max={new Date().getFullYear()}
        />
      </div>
      <div className="w-3/4 mb-5 items-end justify-end self-end">
        <select
          name="filterDay"
          className="border p-2 m-2"
          value={filterDay}
          onChange={(e) => setFilterDay(e.target.value)}
          disabled={!selectedMonth}
        >
          <option value="" disabled>Filter by Day</option>
          {selectedMonth &&
            Array.from({ length: getDaysInMonth(selectedMonth) }, (_, i) => i + 1)
              .map((day) => (
                <option key={day} value={day}>{day}</option>
              ))}
        </select>
        <select
          name="filterStatusP"
          className="border p-2 m-2"
          value={filterStatusP}
          onChange={(e) => setFilterStatusP(e.target.value)}
        >
          <option value="">Filter by Status</option>
          <option value="Ordered">Ordered</option>
          <option value="Received">Received</option>
          <option value="Sent">Sent</option>
          <option value="Sold">Sold</option>
          <option value="Custom">Custom</option>
          <option value="Returned">Returned</option>
          <option value="Unpaid">Unpaid</option>
        </select>
        <input
          type="text"
          placeholder="Filtered by Model"
          className="border p-2 m-2"
          value={filterModel}
          onChange={(e) => setFilterModel(e.target.value)}
        />
        <button
          onClick={handleClear}
          className="border p-2 m-2 bg-slate-500 hover:bg-slate-300 rounded"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default MonthFilter;
